import React, { useState } from 'react';
import './RecommendationSection.css';
import coffee1 from '../pictures/coffee1.jpg';
import coffee2 from '../pictures/coffee2.jpg';
import coffee3 from '../pictures/coffee3.jpg';
import coffee4 from '../pictures/coffee4.jpg';
import coffee5 from '../pictures/coffee5.jpg';
import restaurant1 from '../pictures/restaurant1.jpg';
import restaurant2 from '../pictures/restaurant2.jpg';
import restaurant3 from '../pictures/restaurant3.jpg';

interface RecommendationSectionProps {
  restaurants: any[];
  placeType?: 'restaurant' | 'cafe';
}

const RecommendationSection: React.FC<RecommendationSectionProps> = ({ restaurants, placeType = 'restaurant' }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [recommendedRestaurant, setRecommendedRestaurant] = useState<any | null>(null);
  const [randomImage, setRandomImage] = useState<string>('');

  // 랜덤 이미지 선택 함수
  const getRandomImage = () => {
    const restaurantImages = [restaurant1, restaurant2, restaurant3];
    const cafeImages = [coffee1, coffee2, coffee3, coffee4, coffee5];
    
    if (placeType === 'cafe') {
      return cafeImages[Math.floor(Math.random() * cafeImages.length)];
    } else {
      return restaurantImages[Math.floor(Math.random() * restaurantImages.length)];
    }
  };

  const handleRandomRecommendation = () => {
    if (restaurants.length === 0) {
      alert('먼저 현재 위치를 설정해주세요!');
      return;
    }

    setIsLoading(true);
    
    // 로딩 애니메이션 시뮬레이션
    setTimeout(() => {
      const randomIndex = Math.floor(Math.random() * restaurants.length);
      setRecommendedRestaurant(restaurants[randomIndex]);
      setRandomImage(getRandomImage()); // 새로운 랜덤 이미지 선택
      setIsLoading(false);
    }, 1500);
  };

  const handleMapView = () => {
    if (recommendedRestaurant && recommendedRestaurant.place_url) {
      window.open(recommendedRestaurant.place_url, '_blank');
    }
  };

  const handleAnotherRecommendation = () => {
    handleRandomRecommendation();
  };

  // 카테고리 추출 함수
  const getCategory = (place: any) => {
    if (place.category_name) {
      const categories = place.category_name.split(' > ');
      return categories[categories.length - 1];
    }
    return '음식점';
  };

  // 거리 계산 함수 (미터 단위를 km 또는 m로 변환)
  const formatDistance = (distance: string) => {
    const distanceNum = parseInt(distance);
    if (distanceNum >= 1000) {
      return `${(distanceNum / 1000).toFixed(1)}km`;
    }
    return `${distanceNum}m`;
  };

  return (
    <div className="recommendation-section">
      <div className="recommendation-button-container">
        <button 
          className="recommendation-button"
          onClick={handleRandomRecommendation}
          disabled={isLoading}
        >
          {isLoading ? '🎲 추천 중...' : '🎲 랜덤 추천받기!'}
        </button>
      </div>

      {(recommendedRestaurant || isLoading) && (
        <div className="result-section">
          <h3 className="result-title">🎉 오늘의 추천 장소!</h3>
          
          {isLoading ? (
            <div className="loading-card">
              <div className="loading-spinner"></div>
              <p>맛집을 찾고 있어요...</p>
            </div>
          ) : recommendedRestaurant && (
            <div className="restaurant-card">
              <div className="restaurant-image">
                <img src={randomImage} alt="추천 장소" className="restaurant-img" />
              </div>
              
              <div className="restaurant-info">
                <h4 className="restaurant-name">🏪 {recommendedRestaurant.place_name}</h4>
                <p className="restaurant-details">
                  🏷️ {getCategory(recommendedRestaurant)}
                  {recommendedRestaurant.distance && ` • 📍 ${formatDistance(recommendedRestaurant.distance)}`}
                </p>
                {recommendedRestaurant.phone && (
                  <p className="restaurant-details">
                    📞 {recommendedRestaurant.phone}
                  </p>
                )}
                {(recommendedRestaurant.road_address_name || recommendedRestaurant.address_name) && (
                  <p className="restaurant-address">
                    📍 {recommendedRestaurant.road_address_name || recommendedRestaurant.address_name}
                  </p>
                )}
              </div>
              
              <div className="action-buttons">
                <button className="action-btn primary" onClick={handleMapView}>
                  카카오맵에서 보기
                </button>
                <button className="action-btn secondary" onClick={handleAnotherRecommendation}>
                  다른 곳 추천
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RecommendationSection;